import React from "react";

const PrevisionsTresorerie = () => {
  return (
    <div className="previsions-tresorerie">
      <h2>Prévisions de trésorerie</h2>
      <p>Outils de prévision des flux de trésorerie.</p>
    </div>
  );
};

export default PrevisionsTresorerie;
